import { Menu as MenuCore } from '@studiometa/ui';
import { withResponsiveOptions, useResize } from '@studiometa/js-toolkit';

/**
 * Menu
 */
export default class Menu extends withResponsiveOptions(MenuCore) {
  /**
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'Menu',
    components: {
      ...MenuCore.config.components,
      Menu,
    },
    options: {
      ...MenuCore.config.options,
      mode: {
        ...MenuCore.config.options.mode,
        responsive: true,
      },
    },
    emits: [
      'enter',
      'leave',
      'btn-click',
      'btn-mouseenter',
      'btn-mouseleave',
      'list-mouseleave',
      'list-items-open',
    ],
  };

  scrollLockBreakpoints = ['xxs', 'xs', 's'];

  /**
   * Breakpoint
   * @returns {string}
   */
  get breakpoint() {
    return useResize().props().breakpoint;
  }

  /**
   * onMouseenter
   */
  onMouseenter() {
    this.$emit('enter');
  }

  /**
   * onMouseleave
   */
  onMouseleave() {
    this.$emit('leave');
  }

  /**
   * toggle
   */
  toggle() {
    super.toggle();

    if (this.scrollLockBreakpoints.includes(this.breakpoint)) {
      document.body.classList.toggle('is-menu-open', this.menuList.isOpen);
    }
  }
}
